import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  AutocompleteModule,
} from 'beyond-util';
import { RezervacijeComponent } from './rezervacije.component';

@NgModule({
  declarations: [RezervacijeComponent],
  entryComponents: [RezervacijeComponent],
  exports: [RezervacijeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    AutocompleteModule,
    NgxSpinnerModule,
  ],
})
export class RezervacijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/rezervacije/rezervacije.module.ts